module.exports = __webpack_public_path__ + "media/bootstrap-icons/border-left-e98d0f4b.svg";